import { MNHotInstance } from '../../../tableHotInstanceTypes';

/**
 * Returns the final non-empty column index, accounting for readonly cells that still render content.
 */
export const lastColWithContent = (hotInstance: MNHotInstance): number | undefined => {
    for (let colIndex = hotInstance.countCols() - 1; colIndex >= 0; colIndex--) {
        const cellsMeta = hotInstance.getCellsMeta();
        const currentColCells = cellsMeta.filter((cellMeta) => cellMeta?.col === colIndex);
        const colContainsReadonlyCells = currentColCells.some((cellMeta) => cellMeta.readOnly);

        if (!hotInstance.isEmptyCol(colIndex) || colContainsReadonlyCells) return colIndex;
    }
};

/**
 * Returns the final non-empty row index, accounting for readonly cells that still render content.
 */
export const lastRowWithContent = (hotInstance: MNHotInstance): number | undefined => {
    for (let rowIndex = hotInstance.countRows() - 1; rowIndex >= 0; rowIndex--) {
        const rowMeta = hotInstance.getCellMetaAtRow(rowIndex);
        const rowContainsReadonlyCells = rowMeta.some(({ cellData }): boolean => !!cellData?.readOnly);

        if (!hotInstance.isEmptyRow(rowIndex) || rowContainsReadonlyCells) return rowIndex;
    }
};
